import request from '@/utils/request'



// getDepts
export const getDeptList = () => {
  return request({
    url: '/api/dept',
    method: 'GET'
    // params:params
  })
}

// 上传图片
export const ossPrivateConfig = params => {
  return request({
    url: '/api/ossPrivateConfig',
    method: 'POST',
    data: params
  })
}

export const getReprotListDetail = id => {
  return request({
    url: '/api/report/'+id,
    method: 'GET'
  })
}
export const getOssPrivateConfig = id => {
  return request({
    url: '/api/ossConfig/download/'+id,
    method: 'GET'
    // params:params
  })
}

// 获取标签页  

export const labelListForReport = () => {
  return request({
    url: '/api/label',
    method: 'GET'
    // params:params
  })
}


// /api/categoryList 获取报告类别

export const categoryForReportList = () => {
  return request({
    url: '/api/categoryForReport',
    method: 'GET'
    // params:params
  })
}

export const categoryForReportList1 = () => {
  return request({
    url: '/api/categoryForReport1',
    method: 'GET'
    // params:params
  })
}
// /api/categoryList 状态

export const getState = () => {
  return request({
    url: '/api/state',
    method: 'GET'
    // params:params
  })
}

export const getKeyPieceCertificState = () => {
  return request({
    url: '/api/keyPieceCertific/state',
    method: 'GET'
    // params:params
  })
}

// 添加标签
export const addLabel = params => {
  return request({
    url: '/api/labels',
    method: 'POST',
    data: params
  })
}

// 图片预览下载
// 
export const showFiles = params => {
  return request({
    url: '/api/ossConfig/download',
    method: 'GET',
    params:params
  })
}

// 数据范围组
export const getDataRange = id => {
  return request({
    url: '/api/datarange/user/' + id,
    method: 'GET',
  })
}

// 获取数据范围（监控）
export const getDataRangeTwo = id => {
  return request({
    url: '/api/datarange/sub/' + id,
    method: 'GET',
  })
}